export default "__VITE_ASSET__BVnhY6$F__"